function stubFalse(){return!1}module.exports=stubFalse;